export const SEARCH_COMPONENT_WIDTH = 490;

export const SEARCH_COMPONENT_HEIGHT = 40;
